import { create } from "zustand";

export const useClickStore = create((set) => ({
  clickType: "pan",
  setClickType: (clickType_) =>
    set({
      clickType: clickType_,
      instanceId: null,
      hideLayerKey: null,
      measure_points: [],
    }),
  measure_points: [],
  setClickParams: (point, object, instanceId, layerKey) => {
    set((state) => {
      const id = Number.isInteger(instanceId) ? instanceId : (instanceId == null || instanceId === '' ? NaN : Math.floor(Number(instanceId)));
      const hasInstance = Number.isInteger(id) && id >= 0;
      const pickFn = object?.userData?.pickInstance || object?.userData?.pickPoint;
      const instanceRow = hasInstance
        ? typeof pickFn === 'function'
          ? pickFn(id)
          : object.userData.instancesData?.[id]
        : null;
      const canInspect = !!(object?.userData?.displayData || object?.userData?.instancesData || pickFn);
      return {
      objectDetails:
        state.clickType === "info"
          ? hasInstance
            ? instanceRow
            : object.userData.displayData
              ? object.userData.displayData
              : null
          : null,
      objectDetailsPosition:
        state.clickType === "info" && canInspect
          ? point
          : null,
      objectDetailsObject:
        state.clickType === "info" && canInspect
          ? object
          : null,
      measure_points:
        state.clickType === "distance" && state.measure_points.length < 2
          ? [...state.measure_points, point]
          : state.clickType === "distance"
            ? [point]
            : [],
      zoomPosition: state.clickType === "zoom" ? point : null,
      clickType: state.clickType === "zoom" ? "pan" : state.clickType,
      colorMaterial: state.clickType === "color" ? object.material : null,
      currentObjectName: object.name,
      instanceId:
        state.clickType === "info" ? (hasInstance ? id : null) : null,
      hideLayerKey:
        state.clickType === "hide"
          ? layerKey || object?.userData?.mdvLayerKey || null
          : null,
      selectedMeasureId: null,
      };
    });
  },
  hideLayerKey: null,
  clearHideLayerKey: () => set({ hideLayerKey: null }),
  instanceId: null,
  objectDetails: "",
  objectDetailsPosition: null,
  objectDetailsObject: null,
  zoomPosition: null,
  colorMaterial: null,
  currentObjectName: null,
  zoomToExtent: false,
  setZoomToExtent: (z) => set({ zoomToExtent: z }),
  showLabels: false,
  setLabels: () => set((state) => ({ showLabels: !state.showLabels })),
  showMeasurements: false,
  setShowMeasurements: (show) => set({ showMeasurements: show }),
  toggleMeasurements: () =>
    set((state) => ({ showMeasurements: !state.showMeasurements })),
  gradeLegends: {},
  setGradeLegend: (name, gradeKey, visible) =>
    set((state) => {
      const next = { ...(state.gradeLegends || {}) };
      if (visible) {
        next[name] = gradeKey || "";
      } else {
        delete next[name];
      }
      return { gradeLegends: next };
    }),
  lithLegends: {},
  setLithLegend: (name, codes, visible) =>
    set((state) => {
      const next = { ...(state.lithLegends || {}) };
      if (visible) {
        next[name] = Array.isArray(codes) ? codes : [];
      } else {
        delete next[name];
      }
      return { lithLegends: next };
    }),
  isFlyAroundActive: false,
  setFlyAround: (active) => set({ isFlyAroundActive: active }),
  planLocked: false,
  setPlanLocked: (locked) => set({ planLocked: Boolean(locked) }),
  togglePlanLocked: () => set((state) => ({ planLocked: !state.planLocked })),
  snapEnabled: true,
  setSnapEnabled: (enabled) => set({ snapEnabled: enabled !== false }),
  toggleSnapEnabled: () => set((state) => ({ snapEnabled: !state.snapEnabled })),
  lastSnap: null,
  setLastSnap: (lastSnap) => set({ lastSnap: lastSnap || null }),
  selectedMeasureId: null,
  setSelectedMeasureId: (id) => set({ selectedMeasureId: id || null }),
}));

function formatPickLine(pick) {
  const name = String(pick?.name || 'Object').trim() || 'Object';
  const east = Number(pick?.east);
  const north = Number(pick?.north);
  const rl = Number(pick?.rl);
  if (!Number.isFinite(east) || !Number.isFinite(north) || !Number.isFinite(rl)) {
    return name;
  }
  return `${name}   coords:E:${east.toFixed(1)} N:${north.toFixed(1)} RL:${rl.toFixed(1)}`;
}

export const useInforStore = create((set) => ({
  info: "...",
  pick: null,
  setInfo: (info_) => {
    if (info_ && typeof info_ === 'object' && !Array.isArray(info_)) {
      const name = String(info_.name || 'Object').trim() || 'Object';
      const east = Number(info_.east);
      const north = Number(info_.north);
      const rl = Number(info_.rl);
      const hasCoords =
        Number.isFinite(east) && Number.isFinite(north) && Number.isFinite(rl);
      const pick = hasCoords
        ? { name, east, north, rl }
        : { name, east: null, north: null, rl: null };
      set({ pick, info: formatPickLine(pick) });
      return;
    }
    set({ info: info_ ?? '...', pick: null });
  },
}));
